function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".security_svg__d,.security_svg__g{fill:#fff}.security_svg__f{stroke:#1d1f2c}.security_svg__d,.security_svg__e,.security_svg__f,.security_svg__g{stroke-width:2px}.security_svg__d,.security_svg__e,.security_svg__g{stroke:#d32f2f}.security_svg__e,.security_svg__f,.security_svg__i{fill:none}.security_svg__e,.security_svg__f,.security_svg__g{stroke-linecap:round}.security_svg__g{stroke-linejoin:round}.security_svg__h{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.739 68.596a22.994 22.994 0 010-32.525L35.313 8.497A23 23 0 1167.84 41.022L40.264 68.596a22.994 22.994 0 01-32.525 0z",
  fill: "#ffd5d5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.001 9.758)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.001 .242)",
  strokeWidth: 2,
  stroke: "#1d1f2c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__h",
  width: 37,
  height: 58,
  rx: 5
}), /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__i",
  x: 1,
  y: 1,
  width: 35,
  height: 56,
  rx: 4
})), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__d",
  d: "M18.499 25.242a8.5 8.5 0 018.5 8.5v.556a.944.944 0 01-.944.944H10.943a.944.944 0 01-.944-.944v-.556a8.5 8.5 0 018.5-8.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "security_svg__d",
  cx: 4.5,
  cy: 4.5,
  r: 4.5,
  transform: "translate(13.999 16.242)"
}), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__e",
  d: "M10 40h17"
}), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__f",
  d: "M1.465 51h34.666M1.465 10h34.666"
}), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__e",
  d: "M10 44h17M16.999 5h6.5M12.999 5h1"
}), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__g",
  d: "M45.049 59.975l-.053.023v-.049a28.958 28.958 0 01-9.762-7.783C30.759 46.646 31 36.553 31 36.553v-7.854l14-3.672V25l.053.014.053-.014v.029L59.1 28.701v7.854s.24 10.094-4.234 15.613a29.027 29.027 0 01-9.76 7.783V60z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.999 33)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__d",
  width: 8,
  height: 14,
  rx: 4,
  transform: "translate(3 .242)"
}), /*#__PURE__*/React.createElement("g", {
  className: "security_svg__g",
  transform: "translate(0 5.242)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__h",
  width: 14,
  height: 10,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  className: "security_svg__i",
  x: 1,
  y: 1,
  width: 12,
  height: 8,
  rx: 1
})), /*#__PURE__*/React.createElement("path", {
  className: "security_svg__e",
  d: "M7 10.734V9"
})));

var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,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";
export { SvgSecurity as ReactComponent };